import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPassowrdComponent } from './forgot-passowrd.component';

const routes: Routes = [
  {path: '', component: ForgotPassowrdComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ForgotPassowrdRoutingModule { }
